import { Plus } from "lucide-react";

import { MultiFileUploadButton } from "@/components/multi-file-upload-button";
import { Button } from "@/components/ui/button";
import { useUpdateSKUMutation } from "@/data/mutations";
import { addPlaylistTracks } from "@/lib/cms";

import { useCMSContext } from "../cms-context";
import { useCMSTabContext } from "../cms-tab-context";

export const AddTrackButton = () => {
  const { sku, pageContent } = useCMSContext();
  const { tabIndex } = useCMSTabContext();
  const updateSKUMutation = useUpdateSKUMutation(sku.id);

  const handleFileUploadFinish = (
    uploadedFiles: { url: string; file_name: string }[],
  ) => {
    updateSKUMutation.mutate({
      page_content: addPlaylistTracks(pageContent, tabIndex, uploadedFiles),
    });
  };

  return (
    <MultiFileUploadButton fileType="audio" onFinish={handleFileUploadFinish}>
      {(props) => (
        <Button
          type="button"
          variant="secondary"
          className="w-full"
          onClick={props.openFilePicker}
          disabled={props.isUploading}
        >
          {props.isUploading ? (
            <>
              {Math.round((props.uploadedBytes / props.totalBytes) * 100) || 0}%
              - Files {props.currentFileCount} of {props.totalFileCount}
            </>
          ) : (
            <>
              <Plus className="size-4" /> Add files
            </>
          )}
        </Button>
      )}
    </MultiFileUploadButton>
  );
};
